// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"CardsTabs_cardsContainer__xuRtb","executedModal":"CardsTabs_executedModal__1oZna","fadeIn":"CardsTabs_fadeIn___1qZH","fadeOut":"CardsTabs_fadeOut__2YDiz"};